export default ({ children, marginTop, marginBottom, padding }) => (
  <>
    <footer className="footer customFooter">
      <div className="content has-text-centered has-text-grey is-size-7 is-uppercase">
        {children}
      </div>
    </footer>

    <style jsx="true">{`
      .customFooter {
        margin-top: ${marginTop};
        margin-bottom: ${marginBottom};
        padding: ${padding};
      }
    `}</style>
  </>
);
